export default __webpack_public_path__ + "2b9c218beed7b4739ce25207b3d14024.png";